import React from 'react';
import { useFormikContext } from 'formik';

import StreamSelectField from 'data-lake/components/StreamSelectField';
import TimeRangeField from 'data-lake/components/DataLakeActionModals/TimeRangeField';
import InclusionTypeField from 'data-lake/components/DataLakeActionModals/InclusionTypeField';
import FieldsFiltersField from 'data-lake/components/DataLakeActionModals/FieldsFiltersField';
import type { DataLakeActionFormValues, RetrievalFormFieldsComponentProps } from 'data-lake/Types';

const InternalFormFieldsComponent = ({ submitButtonText, hourOnly }: RetrievalFormFieldsComponentProps) => {
  const {
    setFieldValue,
    values: { streamIds },
  } = useFormikContext<DataLakeActionFormValues>();

  return (
    <>
      <StreamSelectField value={streamIds} disabled={false} onChange={(value) => setFieldValue('streamIds', value)} />
      <TimeRangeField submitButtonText={submitButtonText} hourOnly={hourOnly} />
      <InclusionTypeField />
      <FieldsFiltersField />
    </>
  );
};

export default InternalFormFieldsComponent;
